import commonRequest from '@/utils/commonRequest';

const PATH = '/attached-file';

export const uploadFile = (moduleName: string, formData: FormData) => commonRequest({
  url: `${moduleName}/upload`,
  method: 'post',
  data: formData,
});

export const getFile = (fileUid: string) => commonRequest({
  url: `${PATH}/${fileUid}/info`,
  method: 'get',
});

export const downloadFile = (fileUid: string) => commonRequest({
  url: `${PATH}/${fileUid}`,
  method: 'get',
});

/**
 * PDF 다운로드용 별도 함수 추가
 * 251125
 */
export const downloadFileAsBlob = (fileUid: string) => commonRequest({
  url: `${PATH}/${fileUid}`,
  method: 'get',
  responseType: 'blob',
});

/**
 * pdf 업로드 및 썸네일 생성
 * 251128
 */
export const uploadFilePdf = (moduleName: string, formData: FormData) => commonRequest({
  url: `${moduleName}/upload/pdf`,
  method: 'post',
  data: formData,
});
